import React from "react";
import { SvgCommon } from ".";
import { IconModel } from "../../models";

export const DocumentationIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <path d="M20.3333 23.4069H4.49992C2.75102 23.4069 1.33325 21.9891 1.33325 20.2402V4.4069C1.33325 2.658 2.75102 1.24023 4.49992 1.24023H7.93824C8.77809 1.24023 9.58355 1.57386 10.1774 2.16773L11.4891 3.47941C12.083 4.07327 12.8884 4.4069 13.7283 4.4069H20.3333C22.0822 4.4069 23.4999 5.82467 23.4999 7.57357V9.1569M26.8606 13.325L24.2217 21.2416C23.7907 22.5347 22.5805 23.4069 21.2175 23.4069H5.72677C3.56533 23.4069 2.0391 21.2894 2.7226 19.2388L5.36149 11.3222C5.79252 10.0291 7.00263 9.1569 8.36566 9.1569H23.8564C26.0178 9.1569 27.5441 11.2744 26.8606 13.325Z" stroke={props.color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgCommon>
  );
};